import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import endpoints from '../endpoints.ts';
import api from '../api/index.ts';

export const ILLEGIT_REPORT_QUERY_KEY = 'ILLEGIT_REPORT_QUERY_KEY';

const useReadCountByUserId = (
  options?: Partial<UseQueryOptions<number | null>>
) =>
  useQuery({
    queryKey: [
      ILLEGIT_REPORT_QUERY_KEY,
      endpoints.illegitReport.read.count.by.userId(),
    ],
    queryFn: api.illegitReport.read.count.by.userId,
    ...options,
  });

const illegitReportQueryHooks = {
  useReadCountByUserId,
};

export default illegitReportQueryHooks;
